import { z } from 'zod';
import { IsoDate, IsoDateTime, UuidString } from '../primitives.js';

/**
 * S13-BE.1 — Regulatory document (ЭСФ / КПН / tax-summary).
 *
 * Canonical entity для регуляторной отчётности KZ. Генерируется в STAITER,
 * пушится в 1С через Tier 3 (двойной approval). ЭСФ — ст. 412 НК РК.
 */

export const RegulatoryDocKind = z.enum(['esf', 'kpn_100', 'tax_summary']);
export type RegulatoryDocKind = z.infer<typeof RegulatoryDocKind>;

export const RegulatoryDocState = z.enum([
  'draft',
  'pending_approval',
  'approved',
  'pushed_to_1c',
  'rejected',
  'cancelled',
  /** B74 (Ф6, §9.4 п. 7): идёт отправка в 1С по заявке уровня 3 — повторная не пройдёт. */
  'pushing',
]);
export type RegulatoryDocState = z.infer<typeof RegulatoryDocState>;

/** Statutory locale — not user.locale. РК выпускает документы в ru/kk. */
export const RegulatoryLocale = z.enum(['ru', 'kk']);
export type RegulatoryLocale = z.infer<typeof RegulatoryLocale>;

export const RegulatoryDocPeriod = z.object({
  date_from: IsoDate,
  date_to: IsoDate,
});
export type RegulatoryDocPeriod = z.infer<typeof RegulatoryDocPeriod>;

// S-FIX-4: BE list handler omits heavy/internal fields. Made optional for
// list-shape parity (detail endpoint returns full shape via separate query).
export const RegulatoryDoc = z.object({
  id: UuidString,
  entity_id: UuidString.optional(),
  kind: RegulatoryDocKind,
  state: RegulatoryDocState,
  period: RegulatoryDocPeriod,
  source_invoice_ids: z.array(UuidString).optional(),
  payload: z.record(z.unknown()).optional(),
  locale: RegulatoryLocale.optional(),
  created_at: IsoDateTime.optional(),
  posted_at: IsoDateTime.nullable().optional(),
  pushed_at: IsoDateTime.nullable().optional(),
  onec_doc_ref: z.string().nullable().optional(),
  created_by: UuidString.optional(),
  approved_by: z.array(UuidString).optional(),
});
export type RegulatoryDoc = z.infer<typeof RegulatoryDoc>;
